import { AgendaTranslation } from "./agenda-translation";
import { AgendaSpeaker } from "./agenda-speaker";
import { Translatable } from "./translatable.interface";
import { DatexPipe } from "../pipes/datex/datex";
import * as moment from "moment";

export class Agenda implements Translatable
{
    id: number;
    event_id: number;
    user_id: number;
    starts_at: string;
    date_starts_at: Date = null;
    ends_at: string;
    date_ends_at: Date = null;
    updated_at: string;
    translations: AgendaTranslation[] = [];
    date_updated_at: Date = null;
    speakers: AgendaSpeaker[] = [];
    shorted: boolean = true;

    edit: false;

    visible: boolean = true;

    /**
     * constructor
     *
     * @param {Agenda} init
     */
    public constructor(init?: Agenda)
    {
        if (!!init)
        {
            Object.assign(this, init);
            if (this.starts_at) this.date_starts_at = moment.utc(this.starts_at).toDate();
            if (this.ends_at) this.date_ends_at = moment.utc(this.ends_at).toDate();
            if (this.updated_at) this.date_updated_at = moment.utc(this.updated_at).toDate();

            if (init.speakers) {
                this.speakers = [];
                let index = 1;
                init.speakers.forEach(speaker => {
                    speaker.index = index;
                    this.speakers.push(new AgendaSpeaker(speaker));
                    index++;
                });
            }
        } else {
            const datePipe = new DatexPipe();
            this.starts_at = datePipe.transform(this.date_starts_at, 'yyyy-MM-dd HH:mm:ss');
            this.ends_at = datePipe.transform(this.date_starts_at, 'yyyy-MM-dd HH:mm:ss');

        }
    }

    public reindexSpeakers() {
        let index = 1;
        this.speakers.forEach((speaker) => {
            if (!speaker.removed) {
                speaker.index = index;
                index++;
            }
        });
    }

    /**
     * get translated attributes
     *
     * @param locale
     *
     * @return {AgendaTranslation}
     */
    public translateOrNew(locale: string): AgendaTranslation
    {
        let currentTranslation = this.translations.filter(translation => translation.locale === locale )[0];

        if (!currentTranslation)
        {
            currentTranslation        = new AgendaTranslation;
            currentTranslation.locale = locale;

            this.translations.push(currentTranslation);
        }

        return currentTranslation;
    }

    /**
     * translate
     *
     * @param locale
     * @param defaultLocale
     * @return {AgendaTranslation}
     */
    public translate(locale: string, defaultLocale?: string): AgendaTranslation
    {
        return this.translations.filter(translation => { return translation.locale === locale; })[0] ||
            this.translations.filter(translation => { return translation.locale === defaultLocale; })[0] ||
            new AgendaTranslation();
    }
}
